import React, { Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import PageTitle from '../../Layout/Components/PageTitle';

import Strings from '../../translations/Translations';
import CreateVideoModule from '../../modules/video/CreateVideoModule';

export default function Video() {
  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={Strings('create_video')}
          subheading=""
          icon="pe-7s-music"
        />

        <Row>
          <Col md={12}>
            <CreateVideoModule />
          </Col>
        </Row>
      </PageAnimation>
    </Fragment>
  );
}
